import { useT } from '@/i18n'

export function PageFallback() {
  const t = useT()
  return (
    <div className="flex flex-1 flex-col" aria-busy="true" aria-label={t('layout.loadingPage')}>
      <div className="mb-6 space-y-2.5">
        <div className="skeleton h-3 w-28" />
        <div className="skeleton h-7 w-56" />
      </div>
      <div className="glass flex-1 rounded-[var(--radius-panel)] p-5">
        <div className="skeleton mb-5 h-9 w-72" />
        {Array.from({ length: 8 }, (_, index) => (
          <div key={index} className="skeleton mb-4 h-4" style={{ width: `${92 - (index % 3) * 9}%` }} />
        ))}
      </div>
    </div>
  )
}
